<div id="form-container">
  <div
    id="main-form"
    class="col col-m-7 col-l-8 col-xl-8 col-xxl-7 lpb-8">
    <h3 class="ui-heading-3-bold">Congress</h3>

    <div id="metadata">
      <!-- Congress Name -->
      <rds-form-field labelPosition="side-left">
        <rds-control-label>Congress Name</rds-control-label>
        <input rdsInput [value]="congress().formalName || congress().congressName" readonly />
      </rds-form-field>

      <!-- Acronym -->
      @if (congress().acronym) {
        <rds-form-field labelPosition="side-left">
          <rds-control-label>Acronym</rds-control-label>
          <input rdsInput [value]="congress().acronym!" readonly />
        </rds-form-field>
      }
    </div>

    <rds-divider></rds-divider>

    <!-- Event Dates -->
    <div id="metadata">
      <h4 class="ui-heading-4--m">Event</h4>

      <rds-form-field labelPosition="side-left">
        <rds-control-label>Start Date</rds-control-label>
        <input rdsInput [value]="formatDate(congress().milestones.event.startDate)" readonly />
      </rds-form-field>
      @if (!congress().milestones.event.startDateConfirmed) {
        <div class="date-warning">
          <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon-sm"></rds-icon>
          <span class="estimated">Estimated</span>
        </div>
      }

      <rds-form-field labelPosition="side-left">
        <rds-control-label>End Date</rds-control-label>
        <input rdsInput [value]="formatDate(congress().milestones.event.endDate)" readonly />
      </rds-form-field>
      @if (congress().milestones.event.endDate && !congress().milestones.event.endDateConfirmed) {
        <div class="date-warning">
          <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon-sm"></rds-icon>
          <span class="estimated">Estimated</span>
        </div>
      }

      <!-- Location -->
      <rds-form-field labelPosition="side-left">
        <rds-control-label>Location</rds-control-label>
        <input rdsInput [value]="locationText || '—'" readonly />
      </rds-form-field>
    </div>

    <rds-divider></rds-divider>

    <!-- Abstract Deadline -->
    <div id="metadata">
      <h4 class="ui-heading-4--m">Abstract Deadline</h4>

      <rds-form-field labelPosition="side-left">
        <rds-control-label>Date</rds-control-label>
        <input rdsInput [value]="formatDate(congress().milestones.abstractDue.date)" readonly />
      </rds-form-field>
      @if (congress().milestones.abstractDue.date && !congress().milestones.abstractDue.confirmed) {
        <div class="date-warning">
          <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon-sm"></rds-icon>
          <span class="estimated">Estimated</span>
        </div>
      }

      @if (congress().milestones.abstractDue.callForAbstractUrl) {
        <div class="link-row">
          <label class="rds-form-field__label">Call for Abstracts</label>
          <button rds-text-button type="button" (click)="openCallForAbstractsLink()">
            Open Link
            <rds-icon namespace="filled" icon="link"></rds-icon>
          </button>
        </div>
      }
    </div>

    <rds-divider></rds-divider>

    <!-- Late Breaking -->
    <div id="metadata">
      <h4 class="ui-heading-4--m">Late Breaking Abstract Deadline</h4>

      <rds-form-field labelPosition="side-left">
        <rds-control-label>Date</rds-control-label>
        <input rdsInput [value]="formatDate(congress().milestones.lateBreaking.date)" readonly />
      </rds-form-field>
      @if (congress().milestones.lateBreaking.date && !congress().milestones.lateBreaking.confirmed) {
        <div class="date-warning">
          <rds-icon namespace="outlined" icon="warning_triangle" class="warning-icon-sm"></rds-icon>
          <span class="estimated">Estimated</span>
        </div>
      }
    </div>

    <!-- Website -->
    @if (congress().website) {
      <rds-divider></rds-divider>

      <div class="link-row">
        <label class="rds-form-field__label">Website</label>
        <button rds-text-button type="button" (click)="openWebsite()">
          Open Website
          <rds-icon namespace="filled" icon="link"></rds-icon>
        </button>
      </div>
    }
  </div>
</div>
